import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cerrix-icon',
  standalone: true,
  templateUrl: './cerrix-icon.component.html',
  styleUrl: './cerrix-icon.component.scss',
})
export class CerrixIconComponent implements OnInit {
  @Input() icon!: string;
  @Input() size?: number;
  @Input() width?: number;
  @Input() height?: number;
  @Input() color?: string;

  ngOnInit() {
    if (!this.size) {
      this.size = 24;
    }
    if (!this.width) {
      this.width = this.size;
    }
    if (!this.height) {
      this.height = this.size;
    }
    if (!this.color) {
      this.color = '#000';
    }
  }
}
